export enum CrossSellPackages {
    lwt = 'express-lwt',
    tms = 'express-tms',
    both = 'express-both'
  }
